import { render, staticRenderFns } from "./licenseRecord.vue?vue&type=template&id=1958bba7&"
import script from "./licenseRecord.vue?vue&type=script&lang=js&"
export * from "./licenseRecord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports